import React, { useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';
import { useCallback } from "react";
import { api_crud_route, api_list_route, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../Utils';

import { getTokenInfo } from '../../UseToken';
import UseSidebar from '../../UseSidebar';

import Loader from '../Loader/Loader';

import Swal from 'sweetalert2'
import Hosts from '../../Hosts'
import { language } from './Language';
import { color } from "../WEBContent/Color";
import { icon } from '../WEBContent/Icon';

export default function List() {

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    const [permissions, set_permissions] = useState({})
    const [entities, setEntities] = useState([]);
    const [projetos, setProjetos] = useState([]);
    const object_type = 'projetos'
    const [, set_SIDE_BAR] = useState([])

    /*     const fetch_id_info = () => {
            reqGET(api_list_route(getTokenInfo().companycode))
                .then(res => {
                    setData(res.data); setLoading(false)
                    console.log("Projetos criados", data)
                    setProjetos(res.data)
                    console.log(projetos)
    
                })
                .catch(() => 404
                )
        } */
    const fetch_id_info = () => {
        reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                setData(res.data);
                setLoading(false);
                setProjetos(res.data);
            })
            .catch(() => 404);
    }

    useEffect(() => {
        console.log("Projetos criados", data);
    }, [data]);

    useEffect(() => {
        console.log(projetos);
    }, [projetos]);

    let get_permissions = (e, sidebar) => {
        let handleSingleCheck = (e, sidebar) => {
            const name = e;

            let ver_submenu = (node) => {
                if (node.submenu.length !== 0) {

                    node.submenu.forEach(subitem => {

                        if (subitem.path === name) {
                            set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                        }
                        else {
                            ver_submenu(subitem)
                        }

                    })
                }
            }

            sidebar.forEach(node => {
                if (node.path === name && 0) {
                    set_permissions({ edit: node.edit, view: true, remove: node.remove })
                } else
                    ver_submenu(node)
            })
        }

        handleSingleCheck(e, sidebar)
    }


    useEffect(() => {
        fetch_id_info()

        set_lang(localStorage.getItem('lang'))

        UseSidebar().getSidebar(getTokenInfo().profile)
            .then(v => {
                get_permissions(pathname, v)
                set_sidebar(v)
                setLoading(false)
            });
    }, [pathname]);

    useEffect(() => {
        const fetchEntities = async () => {
            try {
                const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/`);
                // Filtra as entidades com entity_type === "2" e mapeia para guardar somente nome e id
                const entitiesOptions = res.data
                    .filter(entity => entity.entity_type === "2")
                    .map(entity => ({
                        id: entity.id,
                        nome: entity.name
                    }));

                setEntities(entitiesOptions);
                console.log("Entities:", entitiesOptions); // Vai exibir apenas o id e nome
            } catch (error) {
                console.error("Erro:", error);
            }
        };

        fetchEntities();
    }, []);

    let fetchApi = useCallback((id) => {
        reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                res.data.forEach((v) => {
                    if (v.info.cfp !== undefined) {
                        v.info.cfp.forEach((v2) => {

                            v2.data_inicio.forEach((v_2) => {
                                //console.log('Array DATA INICIO: ', v_2);

                                if (v_2.estado === 'activo') {
                                    //console.log('data inicio: ', v_2.data);
                                    v2.data_inicio_activo = v_2.data;
                                }
                            })
                            v2.data_submissao.forEach((v_3) => {
                                if (v_3.estado === 'activo') {
                                    v2.data_submissao_activo = v_3.data;
                                }
                            })
                            v2.data_limite_fim.forEach((v_4) => {
                                if (v_4.estado === 'activo') {
                                    v2.data_limite_fim_activo = v_4.data;
                                }
                            })
                        })
                    }
                })

                setData(res.data);
                console.log(data)
                UseSidebar().getSidebar(getTokenInfo().profile)
                    .then(v => {
                        get_permissions(pathname, v)
                        set_SIDE_BAR(v)
                        //setLoading(false)
                    }/* set_SIDE_BAR(v) */);
            })
            .catch(() => 404
                //  TODO: ENVIAR PÝGINA 404
                //alert(error)); 
            )
    }, [pathname])

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: color.corPrimaria.rgb,
            cancelButtonColor: color.corVermelha.rgb,
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })

    }

    const columns = [
        {
            name: language[lang].codProjeto,
            selector: 'info.codProjeto',
            width: '9%',

            cell: row => (
                <span style={{ margin: 0, padding: 0 }}>{row.info.codProjeto}</span>
            ),
            sortable: true,
            left: true,
        },
        {
            name: language[lang].numero_l,
            selector: 'info.nLicenca',
            width: '9%',

            cell: row => (
                <span style={{ margin: 0, padding: 0 }}>{row.info.nLicenca}</span>
            ),
            sortable: true,
            left: true,
        },
        {
            name: language[lang].empresa,
            selector: 'info.empresa',
            width: '9%',

            cell: row => {
                const matchingEntity = entities.find(entity => entity.id === row.info.empresa);

                return (
                    <span style={{ margin: 0, padding: 0 }}>{matchingEntity ? matchingEntity.nome : "ID não encontrado"}</span>
                );
            },
            sortable: true,
            left: true,
        },
        {
            name: language[lang].software,
            selector: 'info.nome',
            width: '9%',
            cell: row => (
                <div>
                    {Array.isArray(row.info.nome) && row.info.nome.length > 0 ? (
                        row.info.nome.map((item, index) => (
                            <div key={index}>
                                <span style={{ margin: 0, padding: 0 }}>{item.nomeCompleto}</span>
                            </div>
                        ))
                    ) : (
                        <span style={{ margin: 0, padding: 0 }}>{language[lang].empty}</span>
                    )}
                </div>
            ),
            sortable: true,
            left: true,
        },
        {
            name: language[lang].assistencia_remota,
            selector: 'info.assistenciaRemota',
            width: '8%',
            center: true,
            cell: row => (
                row.info.assistenciaRemota ?
                    <span className="badge rounded bg-success p-0">
                        <i className="bi bi-check text-white fs-4"></i>
                    </span>
                    :
                    <span className="badge rounded bg-danger p-0">
                        <i className="bi bi-x text-white fs-4"></i>
                    </span>
            ),
            sortable: true,
            left: true,
        },
        {
            name: language[lang].assistencia_permitida,
            selector: 'info.assistenciaPermitida',
            width: '8%',
            center: true,
            cell: row => (
                row.info.assistenciaPermitida ?
                    <span className="badge rounded bg-success p-0">
                        <i className="bi bi-check text-white fs-4"></i>
                    </span>
                    :
                    <span className="badge rounded bg-danger p-0">
                        <i className="bi bi-x text-white fs-4"></i>
                    </span>
            ),
            sortable: true,
            left: true,
        },
        /* 
        {
            name: language[lang].data_creacao,
            selector: 'info.date.creation',
            width: '9%',

            cell: row => (
                <div>
                    {row.info && Array.isArray(row.info.date) && row.info.date.length > 0 ? (
                        row.info.date.map((item, index) => {
                            return (
                                <div key={index}>
                                    <span style={{ margin: 0, padding: 0 }}>{item.available || "Não definido"}</span>
                                </div>
                            );
                        })
                    ) : (
                        <span style={{ margin: 0, padding: 0 }}>{language[lang].undefined}</span>
                    )}
                </div>
            ),
            sortable: true,
            left: true,
        },
        */
        {
            name: language[lang].data,
            selector: 'info.date.published',
            width: '9%',

            cell: row => (
                <div>
                    {row.info && Array.isArray(row.info.date) && row.info.date.length > 0 ? (
                        row.info.date.map((item, index) => {
                            return (
                                <div key={index}>
                                    <span style={{ margin: 0, padding: 0 }}>{item.available || "Não definido"}</span>
                                </div>
                            );
                        })
                    ) : (
                        <span style={{ margin: 0, padding: 0 }}>{language[lang].undefined}</span>
                    )}
                </div>
            ),
            sortable: true,
            left: true,
        },
        {
            name: language[lang].date_update,
            selector: 'info.date.modified',
            width: '9%',

            cell: row => (
                <div>
                    {row.info && Array.isArray(row.info.date) && row.info.date.length > 0 ? (
                        row.info.date.map((item, index) => {
                            return (
                                <div key={index}>
                                    <span style={{ margin: 0, padding: 0 }}>{item.available}</span>
                                </div>
                            );
                        })
                    ) : (
                        <span style={{ margin: 0, padding: 0 }} />
                    )}
                </div>
            ),
            sortable: true,
            left: true,
        },
        {
            name: language[lang].termino_stats,
            selector: 'info.date.available',
            width: '9%',
            cell: row => {
                const currentDate = new Date();

                return (
                    <div>
                        {row.info && Array.isArray(row.info.date) && row.info.date.length > 0 ? (
                            row.info.date.map((item, index) => {
                                const creationDate = new Date(item.available);
                                const isWithinDeadline = creationDate > currentDate;
                                const dateStatus = isWithinDeadline ? "Dentro do prazo" : "Terminou o projeto";

                                return (
                                    <div key={index}>
                                        <span
                                            style={{
                                                color: isWithinDeadline ? color.corVerde.rgb2 : color.corVermelha.rgb,
                                                margin: 0,
                                                padding: 0
                                            }}
                                        >
                                            {dateStatus}
                                        </span>
                                    </div>
                                );
                            })
                        ) : (
                            <span style={{ color: color.corCinza.hexa, margin: 0, padding: 0 }}>{language[lang].undefined}</span>
                        )}
                    </div>
                );
            },
            sortable: true,
            left: true,
        },
        {
            name: language[lang].termino,
            selector: 'info.date.available',
            width: '9%',

            cell: row => (
                <div>
                    {row.info && Array.isArray(row.info.date) && row.info.date.length > 0 ? (
                        row.info.date.map((item, index) => {
                            return (
                                <div key={index}>
                                    <span style={{ margin: 0, padding: 0 }}>{item.available || "Não definido"}</span>
                                </div>
                            );
                        })
                    ) : (
                        <span style={{ margin: 0, padding: 0 }}>{language[lang].undefined}</span>
                    )}
                </div>
            ),
            sortable: true,
            left: true,
        },
        {
            name: '',
            right: true,
            export: false,
            width: '12%',
            minWidth: '110px !important',
            cell: row =>
                <span>

                    <Link className="button button-update button-view d-none" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>

                    {/* 
                    <Link className={true ? "button button-update" : "d-none"} to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }} replace>
                        <i className="bi bi-pencil"></i>
                    </Link>
                    */}

                    {(permissions.edit) && (getTokenInfo().profile === 'Administrador' || getTokenInfo().profile === 'TeamLeader') ? (
                        <Link
                            className={permissions.edit ? "button button-update" : "d-none"}
                            to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }}
                            replace
                        >
                           <i className={icon.pencil.className} style={icon.pencil.style}></i>
                        </Link>
                    ) : null}

                    {permissions.remove && (getTokenInfo().profile === 'Administrador') && (
                        <button
                            className="button button-delete"
                            onClick={() => apagar(row['id'])}
                            aria-label="Delete Ticket"
                        >
                            <i className={icon.trash.className} style={icon.trash.style}></i>
                        </button>
                    )}
                </span >
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <h2 className="dash-title">{language[lang].entity}</h2>
                <p>{language[lang].entity_list}</p>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">
                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body" style={{ marginLeft: '2%' }}>
                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header d-flex justify-content-between align-items-center" style={{ fontSize: '0.8rem' }}>
                                        <div className="button-group-left d-flex">

                                        </div>
                                        {(getTokenInfo().profile === 'Administrador' || getTokenInfo().profile === 'TeamLeader') && (
                                             <div className="table-header text-end mb-8">
                                                <Link className="btn rounded-pill btn-primary py-1 px-4 multi-item"
                                                    to={{ pathname: endpoints.regist }}
                                                    style={{ padding: '0.15rem 1.0rem', fontSize: '0.9rem' }}
                                                >
                                                    <span>{language[lang].add_new}</span>
                                                </Link>
                                            </div>
                                        )}
                                    </div>

                                    <div className="table-body">
                                        <DataTableExtensions {...tableData}>

                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}